var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.3 26.7 30.6 9.4c.5-.5.5-1.6 0-2.1l-2.1-2.1c-.5-.5-1.6-.5-2.1 0l-14 14-7-6.7C5 12 4 12 3.5 12.5l-2.1 2.1c-.5.5-.5 1.6 0 2.1l9.8 9.8c.5.8 1.3.8 2.1.2"
})));
export default SvgIconTick;